export const sessionStorageKeyConstants = {
    SUBMITTED_STATE: "submittedState",
};
